import React from 'react';
import { useSelector } from 'react-redux';
import { useInteractionInsightsTotals } from '@debbie/cortex/dist/interactions/index.js';
import { useCaseInsightsTotals } from '@debbie/cortex/dist/cases/index.js';
import { usePaymentPlansInsights } from '@debbie/cortex/dist/paymentPlans/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import Panel from '../Panel.js';
import DepositsStats from './DepositsStats.js';
import PaymentPlansStats from './PaymentPlansStats.js';
import Stat from './Stat.js';
const StatsPanel = (props) => {
    const { isAdmin } = props;
    const lang = useSelector((s) => s.lang);
    const interactionTotalsData = useInteractionInsightsTotals();
    const interactionTotals = h.hasData(interactionTotalsData)
        ? interactionTotalsData.data
        : null;
    const caseTotalsData = useCaseInsightsTotals();
    const caseTotals = h.hasData(caseTotalsData) ? caseTotalsData.data : null;
    const paymentPlansInsightsData = usePaymentPlansInsights();
    const paymentPlansInsights = h.hasData(paymentPlansInsightsData)
        ? paymentPlansInsightsData.data
        : null;
    return (React.createElement("div", null,
        paymentPlansInsights && (React.createElement(PaymentPlansStats, { paymentPlans: paymentPlansInsights })),
        React.createElement(DepositsStats, null),
        React.createElement(Panel, { header: "Support" },
            React.createElement("a", { href: "https://debbie.zendesk.com/hc/da/requests/", target: "_blank", rel: "noreferrer" },
                React.createElement("img", { src: lang.support.imgsrc, width: "100%", style: {
                        margin: '-20px -20px -25px -20px',
                        width: 'calc(100% + 40px)',
                    } }))),
        caseTotals && (React.createElement(Stat, { header: lang.home.cases, stats: caseTotals, shouldHide: !isAdmin, statType: 'cases' })),
        interactionTotals && (React.createElement(Stat, { header: lang.home.interactions, stats: interactionTotals, statType: 'interactions' }))));
};
export default StatsPanel;
//# sourceMappingURL=StatsPanel.js.map